import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgOpen = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 6" {...props}>
    <path fill="none" stroke="#007AFF" d="m0 1 5.033 4L10 1" />
  </svg>
);
const Memo = memo(SvgOpen);
export default Memo;
